import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import "./styles.css";
import { useOpenCv } from "opencv-react";
import { useEffect, useRef } from "react";

export const LoadingPage = ({ onBegin, onFinish, onGeoBlock }) => {
  const { t } = useTranslation("homeModule");
  const { loaded } = useOpenCv();
  // Store function references in refs to prevent re-renders from function changes
  const onGeoBlockRef = useRef(onGeoBlock);
  const onBeginRef = useRef(onBegin);
  const onFinishRef = useRef(onFinish);

  useEffect(() => {
    const loadFlowInfo = async () => {
      onGeoBlockRef.current().then(async (res) => {
        if (res) {
          const res = await onBeginRef.current();
          if (res && loaded) {
            const timerId = setTimeout(() => onFinishRef.current(), 1000);
            return () => clearTimeout(timerId);
          }
        }
      });
    };

    loadFlowInfo();
  }, [loaded]);

  return (
    <>
      <div className="home-loading-page">
        <CircularProgress
          disableShrink
          color="inherit"
          size={40}
          thickness={4}
        />
        <p className="loading-text">{t("loading-ai")}...</p>
      </div>
    </>
  );
};
